export class LineTypeFilter {
    public IncludeInactive?: boolean;
}

export default LineTypeFilter;